import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Apiurl from "../environment/Apiurl";

const UpdateLabManagement = () => {
  const { id } = useParams();
  const [updateData, setUpdateData] = useState({
    lab_report_id: "",
    lab_source: "",
    lab_name: "",
    lab_address: "",
    report_date: "",
    report_status: "",
    patient_id: "",
    referred_by: "",
    test_type: "",
    test_code: "",
    sample_code: "",
    sample_type: "",
    sample_collected_date: "",
    sample_status: "",
    result_summary: "",
    result_values: "",
    normal_range: "",
    remarks: "",
    charge_amount: "",
    payment_status: "",
    report_file: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Fetch existing record for update
  useEffect(() => {
    if (id) {
      axios
        .get(`${Apiurl}/lab_management/${id}`)
        .then((res) => {
          setUpdateData(res.data);
        })
        .catch((err) => {
          console.error("Error fetching data:", err.message);
        });
    }
  }, [id]);

  // Validation
  const validateForm = () => {
    const newErrors = {};
    if (!updateData.lab_report_id?.trim())
      newErrors.lab_report_id = "* Lab Report ID is required";
    if (!updateData.lab_source?.trim())
      newErrors.lab_source = "* Lab Source is required";
    if (!updateData.lab_name?.trim())
      newErrors.lab_name = "* Lab Name is required";
    if (!updateData.lab_address?.trim())
      newErrors.lab_address = "* Lab Address is required";
    if (!updateData.report_date)
      newErrors.report_date = "* Report Date is required";
    if (!updateData.report_status)
      newErrors.report_status = "* Report Status is required";
    if (!updateData.patient_id?.trim())
      newErrors.patient_id = "* Patient ID is required";
    if (!updateData.referred_by?.trim())
      newErrors.referred_by = "* Referred By is required";
    if (!updateData.test_type?.trim())
      newErrors.test_type = "* Test Type is required";
    if (!updateData.test_code?.trim())
      newErrors.test_code = "* Test Code is required";
    if (!updateData.sample_code?.trim())
      newErrors.sample_code = "* Sample Code is required";
    if (!updateData.sample_type?.trim())
      newErrors.sample_type = "* Sample Type is required";
    if (!updateData.sample_collected_date)
      newErrors.sample_collected_date = "* Collected Date is required";
    if (!updateData.sample_status)
      newErrors.sample_status = "* Sample Status is required";
    if (!updateData.result_summary?.trim())
      newErrors.result_summary = "* Result Summary is required";
    if (!updateData.result_values?.trim())
      newErrors.result_values = "* Result Values are required";
    if (!updateData.normal_range?.trim())
      newErrors.normal_range = "* Normal Range is required";
    if (!updateData.charge_amount?.toString().trim())
      newErrors.charge_amount = "* Charge Amount is required";
    if (!updateData.payment_status)
      newErrors.payment_status = "* Payment Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCancel = () => {
    navigate("/lab-management");
  };

    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleUpdate = async () => {
    if (!validateForm()) return;

    try {
      await axios.put(`${Apiurl}/lab_management/${id}`, updateData);
      navigate("/lab-management");
    } catch (error) {
      console.error("Update error", error.message);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && !["application/pdf"].includes(file.type)) {
      setErrors({
        ...errors,
        report_file: "Only PDF files are allowed",
      });
      return;
    }
    setUpdateData({ ...updateData, report_file: file ? file.name : "" });
    setErrors({ ...errors, report_file: "" });
  };

  return (
    <div className="p-2">
      <div className="card card-body">
        {/* Patient & Report Details */}
        <h5 className="mb-2 fw-bold text-center">
          Update Patient & Report Details
        </h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Lab Report ID</label>
            <input
              type="text"
              className="form-control"
              value={updateData.lab_report_id}
              onChange={(e) =>
                setUpdateData({ ...updateData, lab_report_id: e.target.value })
              }
            />
            {errors.lab_report_id && (
              <span className="text-danger mt-5">{errors.lab_report_id}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-2">
            <label>Lab Source</label>
            <select
              className="form-control"
              value={updateData.lab_source}
              onChange={(e) =>
                setUpdateData({ ...updateData, lab_source: e.target.value })
              }
            >
              <option value="">Select Lab Source</option>
              <option value="Internal">Internal</option>
              <option value="External">External</option>
            </select>
            {errors.lab_source && (
              <span className="text-danger">{errors.lab_source}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Lab Name</label>
            <input
              type="text"
              className="form-control"
              value={updateData.lab_name}
              onChange={(e) =>
                setUpdateData({ ...updateData, lab_name: e.target.value })
              }
            />
            {errors.lab_name && (
              <span className="text-danger">{errors.lab_name}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-2">
            <label>Lab Address</label>
            <input
              type="text"
              className="form-control"
              value={updateData.lab_address}
              onChange={(e) =>
                setUpdateData({ ...updateData, lab_address: e.target.value })
              }
            />
            {errors.lab_address && (
              <span className="text-danger">{errors.lab_address}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-2">
            <label>Patient ID</label>
            <input
              type="text"
              className="form-control"
              value={updateData.patient_id}
              onChange={(e) =>
                setUpdateData({ ...updateData, patient_id: e.target.value })
              }
            />
            {errors.patient_id && (
              <span className="text-danger">{errors.patient_id}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Referred By</label>
            <input
              type="text"
              className="form-control"
              value={updateData.referred_by}
              onChange={(e) =>
                setUpdateData({ ...updateData, referred_by: e.target.value })
              }
            />
            {errors.referred_by && (
              <span className="text-danger">{errors.referred_by}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Report Date</label>
            <input
              type="date"
              className="form-control"
              value={updateData.report_date}
              onChange={(e) =>
                setUpdateData({ ...updateData, report_date: e.target.value })
              }
            />
            {errors.report_date && (
              <span className="text-danger">{errors.report_date}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Report Status</label>
            <select
              className="form-control"
              value={updateData.report_status}
              onChange={(e) =>
                setUpdateData({ ...updateData, report_status: e.target.value })
              }
            >
              <option value="">Select</option>
              <option value="Pending">Pending</option>
              <option value="Processing">Processing</option>
              <option value="Completed">Completed</option>
            </select>
            {errors.report_status && (
              <span className="text-danger">{errors.report_status}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Report File</label>
            <input
              type="file"
              className="form-control"
              accept="application/pdf"
              onChange={handleFileChange}
            />
            {errors.report_file && (
              <span className="text-danger">{errors.report_file}</span>
            )}
            {updateData.report_file && (
              <p className="mt-1">
                Current File: <strong>{updateData.report_file}</strong>
              </p>
            )}
          </div>
        </div>

        {/* Test Information */}
        <h5 className="mt-3 mb-2 fw-bold text-center">Test Information</h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Test Type</label>
            <input
              type="text"
              className="form-control"
              value={updateData.test_type}
              onChange={(e) =>
                setUpdateData({ ...updateData, test_type: e.target.value })
              }
            />
            {errors.test_type && (
              <span className="text-danger">{errors.test_type}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Test Code</label>
            <input
              type="text"
              className="form-control"
              value={updateData.test_code}
              onChange={(e) =>
                setUpdateData({ ...updateData, test_code: e.target.value })
              }
            />
            {errors.test_code && (
              <span className="text-danger">{errors.test_code}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Type</label>
            <input
              type="text"
              className="form-control"
              value={updateData.sample_type}
              onChange={(e) =>
                setUpdateData({ ...updateData, sample_type: e.target.value })
              }
            />
            {errors.sample_type && (
              <span className="text-danger">{errors.sample_type}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Code</label>
            <input
              type="text"
              className="form-control"
              value={updateData.sample_code}
              onChange={(e) =>
                setUpdateData({ ...updateData, sample_code: e.target.value })
              }
            />
            {errors.sample_code && (
              <span className="text-danger">{errors.sample_code}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Collected Date</label>
            <input
              type="date"
              className="form-control"
              value={updateData.sample_collected_date}
              onChange={(e) =>
                setUpdateData({
                  ...updateData,
                  sample_collected_date: e.target.value,
                })
              }
            />
            {errors.sample_collected_date && (
              <span className="text-danger">
                {errors.sample_collected_date}
              </span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Status</label>
            <select
              className="form-control"
              value={updateData.sample_status}
              onChange={(e) =>
                setUpdateData({ ...updateData, sample_status: e.target.value })
              }
            >
              <option value="">Select</option>
              <option value="Collected">Collected</option>
              <option value="Processed">Processed</option>
              <option value="Rejected">Rejected</option>
            </select>
            {errors.sample_status && (
              <span className="text-danger">{errors.sample_status}</span>
            )}
          </div>
        </div>

        {/* Result Information */}
        <h5 className="mt-3 mb-2 fw-bold text-center">Result Information</h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Result Values</label>
            <input
              type="text"
              className="form-control"
              value={updateData.result_values}
              onChange={(e) =>
                setUpdateData({ ...updateData, result_values: e.target.value })
              }
            />
            {errors.result_values && (
              <span className="text-danger">{errors.result_values}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Normal Range</label>
            <input
              type="text"
              className="form-control"
              value={updateData.normal_range}
              onChange={(e) =>
                setUpdateData({ ...updateData, normal_range: e.target.value })
              }
            />
            {errors.normal_range && (
              <span className="text-danger">{errors.normal_range}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Result Summary</label>
            <textarea
              rows={2}
              className="form-control"
              value={updateData.result_summary}
              onChange={(e) =>
                setUpdateData({ ...updateData, result_summary: e.target.value })
              }
            />
            {errors.result_summary && (
              <span className="text-danger">{errors.result_summary}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Remarks</label>
            <textarea
              rows={2}
              className="form-control"
              value={updateData.remarks}
              onChange={(e) =>
                setUpdateData({ ...updateData, remarks: e.target.value })
              }
            />
          </div>
        </div>

        {/* Payment Information */}
        <h5 className="mt-3 mb-2 fw-bold text-center">Payment Information</h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Charge Amount</label>
            <input
              type="number"
              className="form-control"
              value={updateData.charge_amount}
              min="0"
              onChange={(e) =>
                setUpdateData({ ...updateData, charge_amount: e.target.value })
              }
            />
            {errors.charge_amount && (
              <span className="text-danger">{errors.charge_amount}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Payment Status</label>
            <select
              className="form-control"
              value={updateData.payment_status}
              onChange={(e) =>
                setUpdateData({ ...updateData, payment_status: e.target.value })
              }
            >
              <option value="">Select</option>
              <option value="Paid">Paid</option>
              <option value="Pending">Pending</option>
            </select>
            {errors.payment_status && (
              <span className="text-danger">{errors.payment_status}</span>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-between mt-4">
          <button className="btn btn-success btn-sm" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-primary btn-sm" onClick={handleUpdate}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateLabManagement;
